import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { StringUtils } from '@pwc-bei/common';
import { I18nService, TranslateService } from '@pwc-bei/i18n';
import { ValidatorResult } from '../../models/validator-result';
import { DelegationService } from '../delegation/services/delegation.service';
import { DelegateUtils } from '../../utils/delegate-utils';

@Component({
    selector: 'app-delegation-confirmed',
    templateUrl: './delegation-confirmed.component.html',
    styleUrls: ['./delegation-confirmed.component.scss'],
    standalone: false
})
export class DelegationConfirmedComponent implements OnInit {
  token: string = null;
  delegateId: string = null;
  errors: string[] = [];

  constructor(
    private delegateService: DelegationService,
    private route: ActivatedRoute,
    private translateService: TranslateService,
    private i18n: I18nService,
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      if (!StringUtils.isEmpty(params.token)) {
        this.token = params.token;
      }
      if (!StringUtils.isEmpty(params.id)) {
        this.delegateId = params.id;
      }
    });
    this.delegateService.confirm(this.delegateId, this.token).subscribe({
      next: (data: ValidatorResult) => {
        if (!data.result) {
          this.checkForErrors(data);
        }
      }, error: (error) => {
        this.errors.push(
          this.translateService.instant('delegation-confirmed.error-list.retrieve-info-error')+
          DelegateUtils.delegateErroHandler(error),
        );
      },
    });
  }

  checkForErrors(result: ValidatorResult) {
    this.errors = result.detail.map((detail) => detail.message);
  }
}
